// @flow

import * as React from 'react';

import Opener from './Opener';

/**
 * This component will automatically open a modal/overlay on mount
 * */

type InnerProps = {
  /** let the parent know that the openLayerCheck has been performed */
  markAsCheckedCallback: () => void,

  /** call to check if we should open modal */
  openLayerCheck: () => boolean,

  /** call to open the layer */
  openLayer: () => void,
};

class WrappedAutoOpener extends React.Component<InnerProps> {
  componentDidMount() {
    if (this.props.openLayerCheck()) {
      this.props.openLayer();
    }
    // let the parent know that the check has been performed
    this.props.markAsCheckedCallback();
  }

  render() {
    return null;
  }
}

type OuterProps = {
  /** name of the modal */
  name: string,

  /** local flag passed into the modal */
  local?: boolean,

  /** let the parent know that the openLayerCheck has been performed */
  markAsCheckedCallback: () => void,

  /** call to check if we should open modal */
  openLayerCheck: () => boolean,
};

const AutoOpener = (props: OuterProps) => (
  <Opener name={props.name} local={props.local}>
    {open => (
      <WrappedAutoOpener
        openLayer={open}
        markAsCheckedCallback={props.markAsCheckedCallback}
        openLayerCheck={props.openLayerCheck}
      />
    )}
  </Opener>
);

AutoOpener.defaultProps = {
  local: false,
  markAsCheckedCallback: () => {},
  openLayerCheck: () => true,
};

export default AutoOpener;
